/**
 * Outline icons for NavItem (Figma Nav Items 346:4525). Stroke-only, 24×24 viewBox.
 */

function iconProps() {
  return {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": true,
  };
}

export function NavIconHome() {
  return (
    <svg {...iconProps()}>
      <path
        d="M4.5 9.5 12 4l7.5 5.5V19a.75.75 0 0 1-.75.75H15v-6.25a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0-.75.75V19.75H5.25A.75.75 0 0 1 4.5 19V9.5z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NavIconGiftees() {
  return (
    <svg {...iconProps()}>
      <circle cx="9" cy="8.5" r="2.25" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="15" cy="8.5" r="2.25" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M6 17.25c0-2.25 2.25-3.5 5-3.5s5 1.25 5 3.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function NavIconOccasions() {
  return (
    <svg {...iconProps()}>
      <path
        d="M7.5 5.25v-1M16.5 5.25v-1M5.25 8.25h13.5a1 1 0 0 1 1 1v10.5a1 1 0 0 1-1 1H5.25a1 1 0 0 1-1-1V9.25a1 1 0 0 1 1-1zM4.25 11.25h15.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function NavIconSettings() {
  return (
    <svg {...iconProps()}>
      <path
        d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c0 .66.43 1.25 1 1.51H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
}
